// extracted by mini-css-extract-plugin
module.exports = {"acceptanceButton":"aoq_aor","acceptanceButtonWrapper":"aoq_aos","acceptanceRow":"aoq_aot","acceptanceText":"aoq_aou","banner":"aoq_aov","cookiePolicyLink":"aoq_aow"};